import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import store from "reduxstore/reduxStore";
import { useLocation } from "react-router-dom";
import fleetlogicAPI from "helpers/fleetlogicAPI";
import classnames from "classnames";
import { jwtDecode } from "jwt-decode";
import * as urls from "constants/AppConstants";
import { getConfigEmail } from "actions";
import LoadingScreen from "components/uis/loadingscreen/LoadingScreen";
import "./Settings.scss";
import { debounce, isEmpty } from "lodash";

const OauthVerify = () => {
  const configEmail = useSelector(state => state.configEmail);
  const location = useLocation();
  const [state, setState] = useState({
    type: "",
    text: "",
    isLoading: true
  });

  useEffect(() => {
    store.dispatch(getConfigEmail());
  }, []);

  useEffect(() => {
    if (isEmpty(configEmail?.CompanyEmail)) return;
    const array = location.search.substring(1).split("&");
    const codeArray = {};
    array.forEach(e => {
      codeArray[e.split("=")[0]] = decodeURIComponent(e.split("=")[1]);
    });
    const { code } = codeArray;
    const source = codeArray.state;
    let url = "/rest-api/oauth_token/";
    if (code) {
      let postdata;
      let postdata2;
      switch (source) {
        case "gmail":
          postdata = {
            client_id: process.env.GMAIL_CLIENT_ID,
            client_secret: process.env.GMAIL_CLIENT_SECRET,
            redirect_uri: `${window.location.origin.toString()}${
              urls.REDIRECT_URL
            }`,
            grant_type: "authorization_code",
            code
          };
          postdata2 = {
            smtp_host: "smtp.gmail.com",
            smtp_port: 587,
            smtp_encrypt_type: "TLS"
          };
          break;
        case "microsoft":
        case "outlook":
          postdata = {
            redirect_uri: `${window.location.origin.toString()}${
              urls.REDIRECT_URL
            }`,
            code
          };
          postdata2 = {
            smtp_host: "smtp.office365.com",
            smtp_port: 587,
            smtp_encrypt_type: "TLS"
          };
          url = "/rest-api/oauth/verify/microsoft";
          break;
      }
      fleetlogicAPI
        .post(url, postdata)
        .then(res => {
          const resData = typeof res.data === "string" ? JSON.parse(res.data) : res.data;
          ((postdata2.oauth2_refresh_token = resData.refresh_token),
            (postdata2.smtp_provider = source));
          if (resData.id_token) {
            const userInfo = jwtDecode(resData.id_token);
            postdata2.smtp_id = userInfo.email;
            if (
              postdata2.smtp_id &&
              (resData.refresh_token ||
                postdata2.smtp_id == configEmail.CompanyEmail.smtp_id)
            ) {
              return handleSuccess(postdata2);
            }
          }
          handleError(
            "We couldn't connect to this account, please make sure the email address is correct and then try again later."
          );
        })
        .catch(err => {
          handleError(
            "We couldn't connect to this account, please make sure the email address is correct and then try again later."
          );
        });
    } else {
      handleError(
        "There was an error connecting with the email service, please try later."
      );
    }
  }, [configEmail?.CompanyEmail?.id]);

  const onClose = debounce(() => {
    window.close();
  }, 120);

  const handleSuccess = data => {
    setState({
      type: "success",
      text: `Your email has been connected successfully!`,
      isLoading: false
    });
    fleetlogicAPI
      .put(`${urls.COMPANY_EMAIL_CONFIG}${configEmail.CompanyEmail.id}/`, data)
      .then(res => {
        window.opener.location.reload();
        onClose();
      })
      .catch(err => {
        handleError(
          "We could not configure this email at this time, please try again later."
        );
      });
  };

  const handleError = error => {
    setState({
      type: "error",
      text: error,
      isLoading: false
    });
  };

  return (
    <div
      className={classnames(
        "alert",
        { "alert-success": state.type === "success" },
        { "alert-danger": state.type === "error" }
      )}
      style={{ margin: "20vh 10vw" }}
    >
      <LoadingScreen isLoading={state.isLoading === true} />
      {state.text}
    </div>
  );
};

export default OauthVerify;
